import {defineStore} from 'pinia';

export const useFlatStore = defineStore('flat', {
    state: () => ({
        price: null
    }),
});